<template>
    <div class="eval" id="eval">
       <!-- 我的证书 -->
      <div class="show_input" v-if="status == 3">
        <div style="font-size: 20px;text-align:center;margin-top: 20px">{{title}}</div>
      </div>
      <div class="content_input" v-if="status == 0">
        <div style="font-size: 23px;margin-left: 80px;margin-top: 40px"v-if="studyStatus!==2||fileStatus!==2">您未满足毕业条件，无法获得培训证书</div>
        <div style="font-size: 23px;margin-left: 80px;margin-top: 40px"v-if="studyStatus==2&&fileStatus==2">您已满足结业条件，证书将于结项后发放，请于六月底登录查看</div>
        <div style="font-size: 20px;margin-left: 80px;margin-top: 40px">条件一：完成全部课程学习，并通过所有测评<span style="margin-left: 10px;color:red;font-weight: bold" v-if="studyStatus==2">(已通过)</span><span style="margin-left: 10px;color:red;font-weight: bold" v-if="studyStatus!==2">(未通过)</span></div>
        <div style="font-size: 20px;margin-left: 80px;margin-top: 40px">条件二：提交研修总结并通过审核（与法治教育相关的心得体会或者课程设计）
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus==2">(已通过)</span>
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus!=2">(未通过)</span>
        </div>
        <div style="font-size: 20px;margin-left: 80px;margin-top: 40px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您的研修总结状态：
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus==0">未提交</span>
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus==1">待审核</span>
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus==2">已通过</span>
          <span style="margin-left: 10px;color:red;font-weight: bold" v-if="fileStatus==3">已退回未通过</span>
        </div>
      </div>
      <div class="content_show" v-if="status == 1">
          <div style="width:200px;float:left;height:400px;margin-left: 40px;"><img :src="imgUrl" style="width:551px;height:363px"></div>
         <div style="border:1px solid ;float:left;height:400px;margin-left: 400px;color:#F2F2F2"></div>
        <div style="width:400px;float:left;height:400px;">
          <div style="font-size: 24px;font-weight: bold;margin-left: 60px"> 证书信息</div>
          <div style="background-color:#FFFBF5;margin-left:60px;height: 150px;margin-top: 50px;width: 600px">
          <div style="font-size: 24px;margin-left: 40px;transform:translateY(80%);"> 姓名：{{certification.name}}</div>
          <div style="font-size: 24px;margin-left: 40px;margin-top: 10px;transform:translateY(80%);"> 身份证号：{{certification.idCard}}</div>
          <!--<div style="font-size: 24px;margin-left: 40px;margin-top: 10px;transform:translateY(80%);"> 证书编号：{{certification.certificateNo}}</div>-->
          </div>
          <div class="show_tip" v-if="certificationStatus!==2">
            <div style="margin-left: 20px;font-size: 16px;text-align:left;margin-top: 20px;color:#3692F8; " >您已满足毕业条件，证书生成制作中。。。。<br> {{tip}}</div>
          </div>
          <div class="btnContainer" @click="login" v-if="certificationStatus==2">
            <div   @click="downloadFile" ><img src="../../assets/images/download.png" style="width: 25px;height:20px;margin-top: 10px"></img>下载盖章版证书</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'certification',
    data () {
      return {
        status:0,
        title:'',
        tip:'',
        fileName:'',
        fileBase64:'',
        studyStatus:0,
        fileStatus:0,
        certification:{},
        certificationStatus:0,
        reason:'',
        Headers:{},
        imgUrl:'',
        pdf: '',
        uploaded:'',
        doUpload:'',
        checkStatus: '审核中',
        canUpload:true,
        reUpload:false,
        file:'',
        host: 'https://guopeifile-1251413566.file.myqcloud.com',
        uploadComponent:'',
      }
    },
    mounted() {
      var _this = this;
      this.event = JSON.parse(localStorage.getItem('event'));
      this.getInfo();
    },
    methods:{
      prevFile(){

      },
      getInfo(){
        var _this = this;
        this.post('/certification/info',{eventId:this.event.eventId,},(data)=>{
          if(data.status == 200){
            _this.status=data.data.status
            _this.title=data.data.certificationEvent.title
            _this.tip=data.data.certificationEvent.certificationTip
            _this.fileStatus=data.data.fileStatus
            _this.studyStatus=data.data.studyStatus
            _this.certification=data.data.certification
            _this.certificationStatus=data.data.certification.status
            _this.imgUrl=_this.host+data.data.certification.imgUrl
            _this.pdf=_this.host+data.data.certification.fileUrl

          }
        })
      },
      downloadFile () {
        var downloadElement = document.createElement('a');
        downloadElement.target = "_blank";
        downloadElement.href = this.pdf;
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      },
      handleSuccess(e){
        var _this = this;
        console.log(e);
        _this.$mResToast({
          type:e.status == 200 ? 'success' : 'error',
          msg:e.msg,
          duration:3000,
          isIcon:true,
        });
      },
      toStudy(){
        var _this = this;
        this.post('/reportFile/reportSave',{eventId:this.event.eventId,},(data)=>{
          _this.getUploaded();
        })
      }
    }
  }
</script>
<style scoped>
.content{
  width: 15rem;
  margin: 0.95rem auto;
  padding-bottom: 0.84rem;
}
.icon{
  width: 1.35rem;
  height: 1.35rem;
  margin: 01rem auto 0.5rem auto;
}
.icon img{
  width: 100%;
  height: 100%;
  float: left;
}
.title{
  width: 11rem;
  margin: 0 auto;
  font-size: 0.33rem;
  color: #404040;
  margin-bottom: 0.2rem;
}
.input{
  width: 4.8rem;
  height: 2.91rem;
  border: 0.02rem solid #8b8b8b;
  border-radius: 0.2rem;
  margin: 0.4rem auto;
  cursor: pointer;
}
.show_tip{
  width: 5.8rem;
  height: 1.51rem;
  border: 0.02rem solid #3692F8;
  background-color: #E8F2FE;
  margin: 0.1rem auto;
  margin-top: 20px;
  margin-left: 60px;
  cursor: pointer;
}
.show_input{
  width: 12.8rem;
  height: 0.91rem;
  border: 0.02rem solid #8b8b8b;
  background-color: #FFFBF5;
  margin: 0.1rem auto;
  margin-top: 40px;
  cursor: pointer;
}
.content_input{
  width: 13.8rem;
  height: 4.51rem;
  border: 0.01rem solid #8b8b8b;
  background-color: #FFFBF5;
  margin: 0.1rem auto;
  margin-top: 40px;
  cursor: pointer;
}
.content_show{
  width: 13.8rem;
  height: 4.51rem;
  margin: 0.1rem auto;
  margin-top: 40px;
}
.upload-file{
  float: left;
  height: 2.91rem;
  width: 100%;
}
.btnContainer{
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.64rem;
  margin: 0.58rem auto 0.09rem auto;
  width: 2.31rem;
  height: 0.64rem;
  background-color:#459BF8;
  cursor:pointer;
}
.upload-file >>> .el-upload{
  display: block;
  margin: 0 auto;
}
>>> .el-upload-dragger{
  border: none;
  width: 100%;
  height: 2.86rem;
  border-radius: 0.2rem;
}


.input .upload{
  display: block;
  margin: 0.47rem auto;
}
.input .doc{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.8rem;
  text-align: center;
}
.input .doc img{
  width: 0.41rem;
  height: 0.45rem;
  margin:0 0.21rem;
}
.input .doc span{
  font-size: 0.25rem;
  color: #7f7f7f;
  max-width: 3.6rem;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:3;
}
.input .tip{
  font-size: 0.25rem;
  color: #404040;
  display: block;
  text-align: center;
}
.input .tips{
  font-size: 0.21rem;
  color: #8b8b8b;
  display: block;
  text-align: center;
  margin-top: 0.08rem;
}
.input .sure{
  font-size: 0.25rem;
  color: #404040;
  display: block;
  text-align: center;
}
.input .again{
  font-size: 0.21rem;
  color: #2b73cc;
  display: block;
  width: 1rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 0.2rem;
}
.sumup_ok{
  width: 3.81rem;
  height: 3.9rem;
  display: block;
  margin: 0.5rem auto;
}
.btn{
  width: 1.38rem;
  height: 0.59rem;
  margin: 0 auto;
  background-color: #0073d3;
  color: #fff;
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.59rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/index/Cert.vue